.skip {
  position: absolute;
  top: var(--sp-2);
  left: var(--sp-2);
  z-index: 100;
  padding: var(--sp-2) var(--sp-4);
  background: var(--accent);
  color: var(--text-on-accent);
  border-radius: var(--radius-sm);
  transform: translateY(-200%);
}
.skip:focus {
  transform: none;
}
